// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lz2Q","location":"Header_location__1pntz"};